import { Card } from "reactstrap";
import boxRider from "../../../../assets/images/ayeza-khan-img.png";
import Stars from "../../../../assets/images/StarIcon.png";
import NoStars from "../../../../assets/images/no-selected-star.png";
import { useEffect, useState } from "react";

const ReviewAnalysisCard = (props: any) => {
  var reviewAnalysis = props?.reviewsAnalysis;
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });

  useEffect(() => {
    console.log(props?.reviewsAnalysis, "reviews");
  }, []);

  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return { formattedDate, formattedTime };
  };

  const { formattedDate, formattedTime } = formatDate(
    reviewAnalysis?.review?.createdOn
  );



  const calculateReviewPercentage = () => {
    const rating = reviewAnalysis?.positiveReviewCount || 0;
    const reviews = reviewAnalysis?.reviews || 0;
    if (reviews === 0) return "0%";
    const percentage = (rating / reviews) * 100;
    return `${percentage.toFixed(0)}%`;
  };

  return (
    <>
      <Card className="mainRatingCard">
        <div className="OrderReviewMain d-flex gap-2">
           <input
              type="checkbox"
              className=" mb-auto"
              checked={props.selectedRows.includes(props?.reviewsAnalysis?.product?._id)}
              onChange={(e) => {
                const checked = e.target.checked;
                const id = props?.reviewsAnalysis?.product?._id;
                if (!id) return;

                if (checked) {
                  props.setSelectedRows((prev: any) => [...prev, id]);
                } else {
                  props.setSelectedRows((prev: any[]) => prev.filter(_id => _id !== id));
                }
              }}
            />
          <div className="w-100">
            <table className="AnalysisTable">
              <tbody>
                <tr>
                  <td className="firstChildTD">
                    <div className="d-flex gap-2">
                      <div className="resMobileFir">
                        <div className="orderCard">
                          <div className="profile">
                            <img
                              src={
                                reviewAnalysis?.product?.productImage ||
                                boxRider
                              }
                              alt=""
                            />
                          </div>
                          <div className="contentDv">
                            <h4 title={reviewAnalysis?.product?.productName}>
                              {reviewAnalysis?.product?.productName || "-"}
                            </h4>

                            <div className="d-flex justify-content-start align-items-center gap-1">
                              <p className="sellerSku">
                                Order Item ID:{" "}
                                <span className="fw-bold">
                                  {reviewAnalysis?.product?._id || "-"}
                                </span>
                              </p>
                              <i
                                className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon"
                                data-testing-id="copyColor_order"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigator.clipboard.writeText(
                                    reviewAnalysis?.product?._id
                                  );
                                  setShowModal({
                                    isVisible: true,
                                    color: true,
                                  });
                                  setErrorMessage("SKU Copied!.");
                                  setTimeout(() => {
                                    setShowModal({
                                      isVisible: false,
                                      color: false,
                                    });
                                  }, 1000);
                                  return;
                                }}
                              ></i>
                            </div>
                          </div>
                        </div>
                        <p className="timeDv">
                          Create Time:{" "}
                          <span className="date">{formattedDate}</span>{" "}
                          <span className="time">{formattedTime}</span>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="SecondChildTD">
                    <h1>{reviewAnalysis?.reviews || "-"}</h1>
                  </td>
                  <td className="ThirdChildTD">
                    <h1>
                      <span>{reviewAnalysis?.rating || "-"}</span>
                    </h1>
                  </td>
                  <td className="FourthChildTD">
                    <div className="d-flex align-items-start gap-3">
                      <div className="mt-4">
                        <h4>{reviewAnalysis?.averageRating || "0"}</h4>
                        {/* <p>{reviewAnalysis?.ratingCounts?.fiveStar || "0"} Ratings Score</p> */}
                      </div>
                      <div className="d-flex grapRes">
                        <div className="reviewDvMain">
                          <div className="reviewDv">
                            <div className="d-flex gap-1">
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                            </div>
                          </div>
                          <div className="reviewDv">
                            <div className="d-flex gap-1">
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={NoStars} alt="" />
                            </div>
                          </div>
                          <div className="reviewDv">
                            <div className="d-flex gap-1">
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                            </div>
                          </div>
                          <div className="reviewDv">
                            <div className="d-flex gap-1">
                              <img src={Stars} alt="" />
                              <img src={Stars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                            </div>
                          </div>
                          <div className="reviewDv">
                            <div className="d-flex gap-1">
                              <img src={Stars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                              <img src={NoStars} alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="PROGRESSBAR-END">
                          <div className="d-flex align-items-center gap-2 prog-main">
                            <div className="progressbar">
                              <div className="progress w-100"></div>
                            </div>
                            <p>{reviewAnalysis?.ratingCounts?.fiveStar}</p>
                          </div>
                          <div className="d-flex align-items-center gap-2 prog-main">
                            <div className="progressbar">
                              <div className="progress w-75"></div>
                            </div>
                            <p>{reviewAnalysis?.ratingCounts?.fourStar}</p>
                          </div>
                          <div className="d-flex align-items-center gap-2 prog-main">
                            <div className="progressbar">
                              <div className="progress w-50"></div>
                            </div>
                            <p>{reviewAnalysis?.ratingCounts?.threeStar}</p>
                          </div>
                          <div className="d-flex align-items-center gap-2 prog-main">
                            <div className="progressbar">
                              <div className="progress w-25"></div>
                            </div>
                            <p>{reviewAnalysis?.ratingCounts?.twoStar}</p>
                          </div>
                          <div className="d-flex align-items-center gap-2 prog-main">
                            <div className="progressbar">
                              <div className="progress"></div>
                            </div>
                            <p>{reviewAnalysis?.ratingCounts?.oneStar}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="LastChildTD">
                    <div className="d-flex gap-2">
                      <h6>{calculateReviewPercentage()} ({reviewAnalysis?.positiveReviewCount}/{reviewAnalysis?.reviews})</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Card>
    </>
  );
};

export default ReviewAnalysisCard;
